import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

import GSAP from 'gsap'

import Experience from './Experience'

export default class Camera {
  constructor() {
    //setup
    this.experience = new Experience()
    this.sizes = this.experience.sizes
    this.scene = this.experience.scene
    this.canvas = this.experience.canvas

    //Methods
    this.setCamera()
    this.setControls()
    this.eventCamera()
  }

  setCamera() {
    this.instance = new THREE.PerspectiveCamera(45, this.sizes.width / this.sizes.height, 0.1, 100)

    this.instance.position.set(0, -1, 9)
    this.scene.add(this.instance)
  }
  setControls() {
    this.controls = new OrbitControls(this.instance, this.canvas)
    this.controls.enableDamping = true
    this.controls.maxPolarAngle = Math.PI * 0.45
    this.controls.minAzimuthAngle = -Math.PI * 0.25
    this.controls.maxAzimuthAngle = Math.PI * 0.25
    this.controls.minDistance = 3.5
    this.controls.maxDistance = 12
  }
  eventCamera() {
    const button = document.querySelector('.decouvrir')
    const section = document.querySelector('section')
    button.addEventListener('click', () => {
      //display sections
      if (section.classList.contains('display')) {
        section.classList.remove('display')
      } else {
        section.classList.add('display')
      }
      //move camera
      GSAP.to(this.instance.position, { x: 0, y: 0.5, z: 5, duration: 1.5 })
    })
  }
  resize() {
    this.instance.aspect = this.sizes.width / this.sizes.height
    this.instance.updateProjectionMatrix()
  }

  update() {
    this.controls.update()
  }
}
